<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("configuracion")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-4" v-if="grupoProducto">
                <h2><i class="fa fa-th-large"></i> {{$t("frontalDeVentas")}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="productos" :to="{name:'productos'}">
                                <li>{{$t("productos")}}<br>
                                    <span class="text-muted"><strong>{{$t('componentesDeVenta')}}</strong> {{$t('delNegocioAClientes')}}</span>
                                </li>
                            </router-link>
                            <router-link v-if="categorias" :to="{name:'categorias-generales'}">
                                <li>{{$t('categorias')}}<br>
                                    <span class="text-muted">{{$t('clasificacionDe')}} <strong>{{$t('productosPorFamilia')}}</strong></span>
                                </li>
                            </router-link>
                            <router-link v-if="modificadores && soloRetail" :to="{name:'modificadores'}">
                                <li>{{$t('modificadores')}}<br>
                                    <span class="text-muted">{{$t('elementosQue')}} <strong>{{$t('varianALosProductos')}}</strong> {{$t('paraLaComanda')}}</span>
                                </li>
                            </router-link>
                            <router-link :to="{name:'importacion-sage'}">
                                <li>{{tieneDimoni ? $t('importacionContable') : $t('importacionSage')}}<br>
                                    <span class="text-muted">{{$t('configuracionParaLaImportacionExportacionDeDatosDeSage')}}</span>
                                </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="grupoCompra">
                <h2><i class="fa fa-briefcase"></i> {{$t('gastos')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="materiaPrima" :to="{name:'subproductos'}">
                                <li> {{$t("subproductos")}}<br>
                                    <span class="text-muted"><strong>{{$t('componentesComprados')}}</strong> {{$t('aProveedoresQueComponenProductos')}}</span>
                                </li>
                            </router-link>
                            <router-link v-if="proveedores" :to="{name:'proveedores'}">
                                <li> {{$t("proveedores")}}<br>
                                    <span class="text-muted">{{$t('empresas')}} <strong>{{$t('proveedorasDeMateriasPrimasYServicios')}}</strong> {{$t('alNegocio')}}</span>
                                </li>
                            </router-link>
                            <router-link v-if="casas" :to="{name:'casas'}">
                                <li> {{$t("casas")}}<br>
                                    <span class="text-muted">{{$t('empresas')}} <strong>{{$t('fabricantesDeMateriasPrimas')}}</strong> {{$t('aProveedores')}}</span>
                                </li>
                            </router-link>
                            <router-link v-if="etiquetas" :to="{name:'categorias'}">
                                <li> {{$t("etiquetas")}}<br>
                                    <span class="text-muted"><strong>{{$t('categoriasQueClasifican')}}</strong> {{$t('materiasPrimasYProveedores')}}</span>
                                </li>
                            </router-link>
                            <router-link :to="{ name: 'taxes' }" :class="{ 'highlight-section': !visitedTaxes }">
                            <li :class="{ 
                                'hover-highlight': !visitedTaxes, 
                                'no-hover': !visitedTaxes 
                            }">
                                {{$t("gestionImpuestos")}}<br>
                                <span class="text-muted">{{ $t('administracionTiposTasas') }}<strong>{{$t('administracionTiposTasasImpositivas')}}</strong></span>
                            </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="operarios">
                <h2><i class="fa fa-user-alt"></i> {{$t('operarios')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="operarios" :to="{name:'operarios'}">
                                <li> {{$t("operarios")}}<br>
                                    <span class="text-muted">{{$t('personalCon')}} <strong>{{$t('acceso')}}</strong> {{$t('alSistema')}}</span></li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="clientes">
                <h2><i class="fa fa-users"></i> {{$t('clientes')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="clientes" :to="{name:'clientes'}">
                                <li> {{$t('clientes')}}<br>
                                    <span class="text-muted">{{$t('baseDeDatosDe')}} <strong>{{$t('consumidores')}}</strong> {{$t('enElNegocio')}}</span>
                                </li>
                            </router-link>
                            <!-- <router-link v-if="clientes" :to="{name:'categorias-clientes'}">
                                <li>Categorias clientes<br>
                                    <span class="text-muted"><strong>Categorías que clasifican</strong> clientes</span>
                                </li>
                            </router-link> -->
                        </ul>
                    </div>
                </card>
            </div>


            <div class="col-md-4" v-if="agencias">
                <h2><i class="fa fa-male"></i> {{$t('agencias')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="agencias" :to="{name:'agencias'}">
                                <li> {{$t('agencias')}}<br>
                                    <span class="text-muted">{{$t('clasificacionDeLa')}} <strong>{{$t('procedencia')}}</strong> {{$t('deLasVentas')}}</span>
                                </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="formasPago">
                <h2><i class="fas fa-credit-card"></i> {{$t('formasDePago')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link v-if="formasPago" :to="{name:'formas-de-pago'}">
                                <li> {{$t('formasDePago')}}<br>
                                    <span class="text-muted"><strong>{{$t('metodosDeCobro')}}</strong> {{$t('enElFrontalDeVenta')}}</span>
                                </li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="rangoHorarios">
                <h2><i class="fas fa-chalkboard-teacher"></i> {{$t('general')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <!--
                            <router-link :to="{name:'datos-fiscales'}">
                                <li>Datos fiscales<br>
                                    <span class="text-muted">Configuracion de datos fiscales para informes</span></li>
                            </router-link>
                            -->
                            <router-link :to="{name:'rangos-horarios'}">
                                <li>{{$t('rangosHorarios')}}<br>
                                    <span class="text-muted">{{$t('intervaloDeHorasParaConsultarVentas')}}</span></li>
                            </router-link>
                            <router-link v-if="soloRetail" :to="{name:'rangos-de-mesas'}">
                                <li>{{$t('rangosDeMesas')}}<br>
                                    <span class="text-muted">{{$t('agrupacionesDeMesasParaConsultarVentas')}}</span></li>
                            </router-link>
                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="almacen">
                <h2><i class="fas fa-warehouse"></i> {{$t('almacen')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link :to="{name:'configuracion-almacen'}">
                                <li>{{$t('configurarAlmacén')}}<br>
                                    <span class="text-muted">{{$t('relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen')}}</span></li>
                            </router-link>

                        </ul>
                    </div>
                </card>
            </div>

            <div class="col-md-4" v-if="grupoProducto">
                <h2><i class="fas fa-cog"></i> {{$t('herramientas')}}</h2>
                <card>
                    <div class="content-card">
                        <ul class="list-files">
                            <router-link :to="{name:'herramientas'}">
                                <li>{{$t('herramientasGenerales')}}<br>
                                    <span class="text-muted">{{$t('edicionMasiva')}}</span></li>
                            </router-link>

                        </ul>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        created() {
            this.$store.dispatch("setNameRoute", "Configuración");
            this.restrictions();
            this.getConfigDimoni();
            this.getTpvsRetail();
            
            if (localStorage.getItem('visitedTaxes') === 'true') {
                this.visitedTaxes = true; 
            }
        },
        data() {
            return {
                //COMPRAS
                materiaPrima: true,
                proveedores: true,
                etiquetas: true,

                grupoCompra: true,

                //PRODUCTOS
                productos: true,
                categorias: true,
                modificadores: true,

                grupoProducto: true,

                //CLIENTES
                clientes: true,

                //CASAS
                casas: true,

                //OPERARIOS
                operarios: true,

                //AGENCIAS
                agencias: true,

                //FORMAS DE PAGO
                formasPago: true,

                //ALMACEN
                almacen:true,

                //RANGO HORARIOS
                rangoHorarios:true,

                //SAGE
                idsBusiness: [],
                idsTPV: [],

                //DIMONI
                tieneDimoni: false,
                //RETAIL
                soloRetail: true,

                //IMPUESTOS
                gestionImpuestos: true,

                // NOVEDAD
                visitedTaxes: false,
                

            }
        },
        methods: {
            /*getSageBusinessData()  {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "importacion/getSageBusinessDataByUser", config)
                    .then(function (response) {

                        if(response.data.result.length > 0) {
                            vm.tieneSageBusiness = true;
                        } 

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },*/

            getConfigDimoni() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(
                        this.$store.getters.apiUrl + "clients/tieneDimoni",
                        config
                    ).then(function(response) {
                        if (response.data.result) {
                            vm.tieneDimoni=true;       
                        } else {
                            vm.tieneDimoni=false;   
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            getTpvsRetail(){
                var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "tpvs/getTpvsRetail", config)
                    .then(function (response) {
                        if(response.data.result){
                            vm.soloRetail = false;
                        }else{
                            vm.soloRetail = true;
                        }
                    })
            },
            restrictions() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByUser", config)
                    .then(function (response) {

                        if (response.data.response) {

                            for (let i = 0; i < response.data.result.length; i++) {

                                switch (response.data.result[i].idRestriction) {

                                    case 9:
                                        vm.materiaPrima = false;
                                        break;
                                    case 10:
                                        vm.proveedores = false;
                                        break;
                                    case 11:
                                        vm.etiquetas = false;
                                        break;
                                    case 12:
                                        vm.productos = false;
                                        break;
                                    case 13:
                                        vm.categorias = false;
                                        break;
                                    case 14:
                                        vm.modificadores = false;
                                        break;
                                    case 15:
                                        vm.clientes = false;
                                        break;
                                    case 16:
                                        vm.casas = false;
                                        break;
                                    case 17:
                                        vm.operarios = false;
                                        break;
                                    case 18:
                                        vm.agencias = false;
                                        break;
                                    case 19:
                                        vm.formasPago = false;
                                        break;
                                    case 49:
                                        vm.almacen = false;
                                        break;
                                    case 51:
                                        vm.rangoHorarios = false;
                                        break;
                                }
                            }

                            if (!vm.materiaPrima && !vm.proveedores && !vm.etiquetas) {
                                vm.grupoCompra = false;
                            }

                            if (!vm.productos && !vm.categorias && !vm.modificadores) {
                                vm.grupoProducto = false;
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    }
</script>
<style scoped>

    h2 {
        margin: 10px 0px;
        font-family: "Numier", "Helvetica Neue", Arial;
        color: #1E22AA;
        font-size: 25px;
        font-weight: bold;
    }

    i {
        font-size: 25px
    }

    .list-files {
        padding: 0;
        margin-bottom: 0px;
    }

    .list-files a:first-child li {
        border-top: none;
    }

    .list-files a li {
        list-style: none;
        padding: 15px 20px;
        font-size: 1.1em;
        border-top: 1px solid #bbb;
        color: #252422;
    }

    .list-files a li span {
        font-size: 0.7em;
    }

    .list-files a li:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.2);
    }

    .content-card {
        /* border-top: 2px solid #00A3AD; */
        border-top: 2px solid #00A3AD;
        padding: 0;
    }

    /* Resaltar nueva sección */
    .highlight-section {
        position: relative;
        display: block;
        background: linear-gradient(90deg, #FFFFFF, #8ACED4, transparent);
        /* background: linear-gradient(90deg, #ffcf823a, #f7ac32a9, transparent); */
        /* background: linear-gradient(90deg, rgba(255, 207, 130, 0.2), rgba(247, 172, 50, 0.5), rgba(255, 255, 255, 0)); */
        background-size: 200%;
        /* animation: shine 12.5s infinite; */
    }

    @keyframes shine {
        0% { background-position: 200%; }
        100% { background-position: -200%; }
    }

    .hover-highlight {
        position: relative;
        transition: transform 0.3s ease;
    }

    .hover-highlight::before {
        content: "";
        position: absolute;
        top: 30%;
        left: 80%;
        width: 1.5em;
        height: 1.5em;
        background-image: url('../../../assets/img/stars.svg'); 
        background-size: contain;
        background-repeat: no-repeat;
        opacity: 0;
        filter: brightness(0) invert(1);
        transition: opacity 0.3s ease, filter 0.3s ease;
        animation: glowing-large 1.5s infinite;
        filter: invert(100%) sepia(100%) saturate(500%) hue-rotate(30deg) brightness(1.5) contrast(1.2) drop-shadow(0 0 10px rgba(255, 215, 0, 0.8));
    }

    .highlight-section li.no-hover:hover {
        cursor: pointer;
        background-color: transparent;
        /* box-shadow: 0 0 12px 6px rgba(31, 35, 170, 0.3); */
        box-shadow: 0 0 12px 6px #82CCD2;
        transition: box-shadow 0.3s ease;
    }

    @keyframes glowing-large {
        0% {
            transform: scale(1);
            opacity: 0.5;
            filter: brightness(1) invert(1);
        }
        50% {
            transform: scale(1.3);
            opacity: 1;
            filter: brightness(1.5) invert(1);
        }
        100% {
            transform: scale(1);
            opacity: 0.5;
            filter: brightness(1) invert(1);
        }
    }

    @keyframes glowing-medium {
        0% {
            transform: scale(1);
            opacity: 0.5;
            filter: brightness(1) invert(1);
        }
        50% {
            transform: scale(1.1);
            opacity: 1;
            filter: brightness(1.5) invert(1);
        }
        100% {
            transform: scale(1);
            opacity: 0.5;
            filter: brightness(1) invert(1);
        }
    }

    @keyframes glowing-small {
        0% {
            transform: scale(1);
            opacity: 0.5;
            filter: brightness(1) invert(1);
        }
        50% {
            transform: scale(0.85);
            opacity: 1;
            filter: brightness(1.5) invert(1);
        }
        100% {
            transform: scale(1);
            opacity: 0.5;
            filter: brightness(1) invert(1);
        }
    }

    @media (max-width: 1640px) {
        .hover-highlight::before {
            left: 80%;
        }
        .hover-highlight:hover::before {
            animation: glowing-medium 1.5s infinite;
            transform: scale(1.1);
        }
    }

    @media (max-width: 1500px) {
        .hover-highlight::before {
            top: 20%;
            left: 85%;
        }
        .hover-highlight::before {
            animation: glowing-medium 1.5s infinite;
            transform: scale(1.0);
        }
    }

    @media (max-width: 1400px) {
        .hover-highlight::before {
            top: 18%;
            left: 85%;
        }
        .hover-highlight::before {
            animation: glowing-small 1.5s infinite;
            transform: scale(0.5);
        }
    }

    @media (max-width: 1145px) {
        .hover-highlight::before {
            background-image: none;
        }
    }

    @media (max-width: 990px) {
        .hover-highlight::before {
            left: 85%;
        }
        .hover-highlight::before {
            background-image: url('../../../assets/img/stars.svg'); 
            animation: glowing-medium 1.5s infinite;
            transform: scale(1.0);
        }
    }

    @media (max-width: 900px) {
        .hover-highlight::before {
            left: 85%;
        }
        .hover-highlight::before {
            background-image: none; 
        }
    }   
    
    @media (max-width: 767px) {
        .hover-highlight::before {
            top: 30%;
            left: 75%;
        }
        .hover-highlight::before {
            background-image: url('../../../assets/img/stars.svg'); 
        }
    }   

    @media (max-width: 450px) {
        .hover-highlight::before {
            left: 85%;
        }
        .hover-highlight::before {
            background-image: url('../../../assets/img/stars.svg'); 
        }
    }

    @media (max-width: 375px) {
        .hover-highlight::before {
            top: 15%;
            left: 85%;
        }
        .hover-highlight::before {
            transform: scale(0.5);
        }
    }

    @media (max-width: 374px) {
        .hover-highlight::before {
            background-image: none; 
        }
    }  

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Configuracion.vue